import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { AllergenIcon } from "@/components/z6/AllergenIcon";
import { VegMark } from "@/components/z6/VegMark";
import { CROSS_CONTACT, slugKey } from "@/lib/constants";

const KEY = [
  ["Tree nuts", "Almonds, cashews, walnuts, pistachios and other tree nuts, including nut milks and butters."],
  ["Peanut", "Peanuts and groundnut oil or butter."],
  ["Sesame", "Sesame seeds, tahini and sesame oil."],
  ["Soy", "Soy beans, tofu, tempeh, edamame, miso, soy sauce and tamari."],
  ["Fish", "Any fish, fish sauce or fish stock."],
  ["Crustacean", "Prawns, shrimp, crab, lobster and other shellfish."],
  ["Gluten", "Wheat, barley, rye and anything made from them."],
  ["Dairy", "Milk, cream, butter, cheese, yoghurt, ghee and A2 milk."],
  ["Egg", "Whole eggs, yolks, whites and egg-based sauces."],
  ["Mustard", "Mustard seeds, mustard oil, Dijon and kasundi."],
  ["Celery", "Celery stalks, leaves, seeds and celeriac."],
  ["Sulphites", "Vinegars and dried fruit that can carry sulphites."],
  ["Mushroom", "Any mushroom, including dried mushroom stocks."],
  ["Seeds", "Seeds such as chia, flax, pumpkin and sunflower (shown for guests who avoid them)."],
  ["Caffeine", "Coffee, matcha, green and black tea."],
  ["Coconut", "Coconut milk, cream, water, oil or flesh. Shown for information."],
];

// Touch-friendly, keyboard-accessible legend of every allergen icon plus the cross-contact guidance.
export const AllergenKey = ({ testId = "allergen-key", className = "" }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button type="button" data-testid={`${testId}-btn`} className={`font-ui inline-flex min-h-[48px] items-center gap-2 rounded-full bg-white/85 px-4 text-[15px] text-[#0B2E44] ring-1 ring-[#0B5C8A]/25 active:ring-[#F08DB5] ${className}`}>
        <AllergenIcon name="Gluten" className="h-4 w-4" /> Allergen key
      </button>
    </DialogTrigger>
    <DialogContent data-testid={`${testId}-dialog`} className="max-h-[88vh] max-w-xl overflow-y-auto rounded-3xl bg-white p-7">
      <DialogHeader>
        <DialogTitle className="font-display text-3xl text-[#0B2E44]">Allergen key</DialogTitle>
        <DialogDescription className="font-ui text-[15px] text-[#0B2E44]">What each icon on our cards means.</DialogDescription>
      </DialogHeader>
      <ul className="mt-2 divide-y divide-[#0B2E44]/10">
        {KEY.map(([name, text]) => (
          <li key={name} data-testid={`${testId}-item-${slugKey(name)}`} className="flex items-start gap-4 py-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F2FBFA] text-[#0B2E44] ring-1 ring-[#0B5C8A]/15"><AllergenIcon name={name} className="h-5 w-5" /></span>
            <span><span className="font-ui block text-[16px] font-normal text-[#0B2E44]">{name}</span><span className="font-ui block text-[15px] text-[#0B2E44]">{text}</span></span>
          </li>
        ))}
        <li className="flex items-start gap-4 py-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center gap-1 rounded-full bg-[#F2FBFA] ring-1 ring-[#0B5C8A]/15"><VegMark diet="vegetarian" /></span>
          <span className="font-ui text-[15px] text-[#0B2E44]"><span className="block text-[16px] font-normal text-[#0B2E44]">Veg and non-veg dots</span>Green dot: vegetarian. Red dot: contains meat, fish or shellfish.</span>
        </li>
      </ul>
      <p data-testid={`${testId}-cross-contact`} className="font-ui mt-3 rounded-2xl bg-[#FFF4EF] p-4 text-[15px] leading-relaxed text-[#0B2E44]">{CROSS_CONTACT}</p>
    </DialogContent>
  </Dialog>
);
